const BASE = '/assets/roammyway/destinations'

/**
 * @typedef {Object} Destination
 * @property {string} id
 * @property {string} title Route as the community wrote it, e.g. "Thailand | Vietnam | Cambodia".
 * @property {string} summary Short descriptor for the card and the image alt text.
 * @property {string} image
 */

/** @type {Destination[]} */
export const destinations = [
  {
    id: 'georgia',
    title: 'Georgia',
    summary: 'Caucasus ridgelines and old-town evenings in Tbilisi',
    image: `${BASE}/georgia.svg`,
  },
  {
    id: 'southeast-asia',
    title: 'Thailand | Vietnam | Cambodia',
    summary: 'Temples, night markets and slow river days across three countries',
    image: `${BASE}/thailand.svg`,
  },
  {
    id: 'pacific',
    title: 'New Zealand | Bora-Bora, French Polynesia',
    summary: 'Southern fjords into open Pacific lagoons',
    image: `${BASE}/new-zealand.svg`,
  },
  {
    id: 'southern-africa',
    title: 'South Africa | Zimbabwe',
    summary: 'Cape coastline, high veld and the falls',
    image: `${BASE}/south-africa.svg`,
  },
  {
    id: 'southern-europe',
    title: 'Spain | France | Italy',
    summary: 'A rail loop through three Mediterranean summers',
    image: `${BASE}/europe.svg`,
  },
  {
    id: 'buenos-aires',
    title: 'Buenos Aires, Argentina',
    summary: 'Painted barrios, late dinners and longer nights',
    image: `${BASE}/buenos-aires.svg`,
  },
  {
    id: 'east-asia',
    title: 'Japan | South Korea',
    summary: 'Neon crossings, quiet shrines and mountain onsen',
    image: `${BASE}/japan.svg`,
  },
  {
    id: 'egypt',
    title: 'Cairo | Egypt | Luxor',
    summary: 'The Nile, end to end, with the desert either side',
    image: `${BASE}/egypt.svg`,
  },
]
